import { Injectable } from '@angular/core';
import { CurrencyCode } from '@app/_shared/interfaces/currency-code';

@Injectable({
  providedIn: 'root',
})
export class CurrencyCodeService {
  private list: CurrencyCode[] = [
    { id: 'aed', name: 'UAE dirham' },
    { id: 'afn', name: 'Afganske afghani' },
    { id: 'all', name: 'Albanske lek' },
    { id: 'amd', name: 'Armenske dram' },
    { id: 'ang', name: 'Nederlandske Antiller-gylden' },
    { id: 'aoa', name: 'Angolansk kwanza' },
    { id: 'ars', name: 'Argentinske peso convertible' },
    { id: 'awg', name: 'Arubanske florin' },
    { id: 'aud', name: 'Australske dollar' },
    { id: 'azn', name: 'Aserbajdsjanske manat' },
    { id: 'bam', name: 'Bosnien-Hercegovina konvertible mark' },
    { id: 'bbd', name: 'Barbadisk dollar' },
    { id: 'bdt', name: 'Bangladeshiske taka' },
    { id: 'bgn', name: 'Bulgariske lev' },
    { id: 'bhd', name: 'Bahrainske dinarer' },
    { id: 'bif', name: 'Burundiske francs' },
    { id: 'bmd', name: 'Bermudianske dollar' },
    { id: 'bnd', name: 'Bruneiske dollar' },
    { id: 'bob', name: 'Bolivianske boliviano' },
    { id: 'brl', name: 'Brasilianske real' },
    { id: 'bsd', name: 'Bahamanske dollar' },
    { id: 'btn', name: 'Bhutanesiske ngultrum' },
    { id: 'bwp', name: 'Botswanske pula' },
    { id: 'byn', name: 'Hviderussiske rubler' },
    { id: 'bzd', name: 'Beliziske dollar' },
    { id: 'cad', name: 'Canadiske dollar' },
    { id: 'cdf', name: 'Congolesiske francs' },
    { id: 'chf', name: 'Schweizerfranc' },
    { id: 'clp', name: 'Chilenske peso' },
    { id: 'cny', name: 'Kinesiske yuan renminbi' },
    { id: 'cop', name: 'Colombiansk peso' },
    { id: 'crc', name: 'Costaricanske colón' },
    { id: 'cuc', name: 'Cubanske konvertible peso' },
    { id: 'cup', name: 'Cubanske peso national' },
    { id: 'cve', name: 'Kapverdiske escudo' },
    { id: 'czk', name: 'Tjekkiske koruna' },
    { id: 'djf', name: 'Djiboutiske francs' },
    { id: 'dkk', name: 'Danske kroner' },
    { id: 'dop', name: 'Dominikanske peso' },
    { id: 'dzd', name: 'Algeriske dinarer' },
    { id: 'egp', name: 'Egyptiske pund' },
    { id: 'ern', name: 'Eritreanske nakfa' },
    { id: 'etb', name: 'Etiopiske birr' },
    { id: 'eur', name: 'Euro' },
    { id: 'fjd', name: 'Fijianske dollar' },
    { id: 'fkp', name: 'Falklandsøerne-pund' },
    { id: 'gbp', name: 'Pund sterling' },
    { id: 'gel', name: 'Georgianske lari' },
    { id: 'ghs', name: 'Ghanesisk cedi' },
    { id: 'gip', name: 'Gibraltar-pund' },
    { id: 'gmd', name: 'Gambianske dalasi' },
    { id: 'gnf', name: 'Guineanske francs' },
    { id: 'gtq', name: 'Guatemalanske quetzal' },
    { id: 'gyd', name: 'Guyanske dollar' },
    { id: 'hkd', name: 'Hong Kong-dollar' },
    { id: 'hnl', name: 'Hondurasiske lempira' },
    { id: 'hrk', name: 'Kroatiske kuna' },
    { id: 'htg', name: 'Haitianske gourde' },
    { id: 'huf', name: 'Ungarske forint' },
    { id: 'idr', name: 'Indonesiske rupiah' },
    { id: 'ils', name: 'Israelske ny shekel' },
    { id: 'inr', name: 'Indiske rupee' },
    { id: 'iqd', name: 'Irakiske dinarer' },
    { id: 'irr', name: 'Iranske rial' },
    { id: 'isk', name: 'Islandske krona' },
    { id: 'jmd', name: 'Jamaicanske dollar' },
    { id: 'jod', name: 'Jordanske dinar' },
    { id: 'jpy', name: 'Japanske yen' },
    { id: 'kes', name: 'Kenyanske shilling' },
    { id: 'kgs', name: 'Kirgisiske som' },
    { id: 'khr', name: 'Cambodianske riel' },
    { id: 'kmf', name: 'Comoriske francs' },
    { id: 'kpw', name: 'Nordkoreanske won' },
    { id: 'krw', name: 'Sydkoreanske won' },
    { id: 'kwd', name: 'Kuwaitiske dinarer' },
    { id: 'kyd', name: 'Cayman-øerne-dollar' },
    { id: 'kzt', name: 'Kasakhstanske tenge' },
    { id: 'lak', name: 'Lao kip' },
    { id: 'lbp', name: 'Libanesiske pund' },
    { id: 'lkr', name: 'Srilankanske rupee' },
    { id: 'lrd', name: 'Liberiansk dollar' },
    { id: 'lsl', name: 'Lesotho loti' },
    { id: 'lyd', name: 'Libyske dinarer' },
    { id: 'mad', name: 'Marokkanske dirham' },
    { id: 'mdl', name: 'Moldoviske leu' },
    { id: 'mga', name: 'Madagaskiske ariary' },
    { id: 'mkd', name: 'Makedonske denar' },
    { id: 'mmk', name: 'Myanmar kyat' },
    { id: 'mnt', name: 'Mongolske tugrik' },
    { id: 'mop', name: 'Macau pataca' },
    { id: 'mru', name: 'Mauretanske ouguiya' },
    { id: 'mur', name: 'Mauritiske rupee' },
    { id: 'mvr', name: 'Maldiviske rufiya' },
    { id: 'mwk', name: 'Malawiske kwacha' },
    { id: 'mxn', name: 'Mexicanske peso' },
    { id: 'myr', name: 'Malaysiske ringgit' },
    { id: 'mzn', name: 'Mozambisk metical' },
    { id: 'nad', name: 'Namibiske dollar' },
    { id: 'ngn', name: 'Nigerianske naira' },
    { id: 'nio', name: 'Nicaraguanske cordoba oro' },
    { id: 'nok', name: 'Norske kroner' },
    { id: 'npr', name: 'Nepalesiske rupee' },
    { id: 'nzd', name: 'New Zealand-dollar' },
    { id: 'omr', name: 'Omanske rial' },
    { id: 'pab', name: 'Panamanske balboa' },
    { id: 'pen', name: 'Peruvianske nuevo sol' },
    { id: 'pgk', name: 'Papua New Guineanske kina' },
    { id: 'php', name: 'Filippinske peso' },
    { id: 'pkr', name: 'Pakistanske rupee' },
    { id: 'pln', name: 'Polske zloty' },
    { id: 'pyg', name: 'Paraguayanske guarani' },
    { id: 'qar', name: 'Qatar rial' },
    { id: 'ron', name: 'Rumænske leu' },
    { id: 'rsd', name: 'Serbiske dinarer' },
    { id: 'rub', name: 'Russiske rubler' },
    { id: 'rwf', name: 'Rwandiske francs' },
    { id: 'sar', name: 'Saudiarabiske riyal' },
    { id: 'sbd', name: 'Salomonøerne-dollar' },
    { id: 'scr', name: 'Seychellisk rupee' },
    { id: 'sdg', name: 'Sudaniske pund' },
    { id: 'sek', name: 'Svenske kronar' },
    { id: 'sgd', name: 'Singaporeanske dollar' },
    { id: 'shp', name: 'Sankt Helena-pund' },
    { id: 'sll', name: 'Sierraleonske leone' },
    { id: 'sos', name: 'Somalisk shilling' },
    { id: 'srd', name: 'Surinamesiske dollar' },
    { id: 'ssp', name: 'Sydsudanske pound' },
    { id: 'stn', name: 'Sao Tome og Principe dobra' },
    { id: 'svc', name: 'Salvadoranske colon' },
    { id: 'syp', name: 'Syriske pund' },
    { id: 'szl', name: 'Swazi lilangeni' },
    { id: 'thb', name: 'Thailandske baht' },
    { id: 'tjs', name: 'Tadsjikistansk somoni' },
    { id: 'tmt', name: 'Turkmenistanske manat' },
    { id: 'tnd', name: 'Tunesiske dinar' },
    { id: 'top', name: "Tongansk pa'anga" },
    { id: 'try', name: 'Tyrkiske lira' },
    { id: 'ttd', name: 'Trinidad og Tobago-dollar' },
    { id: 'twd', name: 'Nytaiwanske dollar' },
    { id: 'tzs', name: 'Tanzanisk shilling' },
    { id: 'uah', name: 'Ukrainsk hryvnia' },
    { id: 'ugx', name: 'Ugandiske shilling' },
    { id: 'usd', name: 'Amerikanske dollar' },
    { id: 'uyu', name: 'Uruguayske peso' },
    { id: 'uzs', name: 'Usbekiske sum' },
    { id: 'ves', name: 'Venezuelanske bolivar soberano' },
    { id: 'vnd', name: 'Vietnamesiske dong' },
    { id: 'vuv', name: 'Vanuatu vatu' },
    { id: 'wst', name: 'Samoanske tala' },
    { id: 'xaf', name: 'Centralafrikanske CFA franc BEAC' },
    { id: 'xcd', name: 'Østcaribiske dollar' },
    { id: 'xof', name: 'Vestafrikanske CFA franc BCEAO' },
    { id: 'xpf', name: 'CFP franc' },
    { id: 'yer', name: 'Yeminitiske rial' },
    { id: 'zar', name: 'Sydafrikanske rand' },
    { id: 'zmw', name: 'Zambianske kwacha' },
    { id: 'zwl', name: 'Zimbabwe dollar' },
  ];

  getList(): CurrencyCode[] {
    return this.list;
  }
}
